import { NavigateFunction } from 'react-router-dom';
import { HOME_PATH } from './paths';

/**
 * Navigate back if there's history, otherwise go home.
 * Use this instead of hardcoding navigate(-1) or navigate('/dashboard').
 */
export function goBackOrHome(navigate: NavigateFunction) {
  if (window.history.length > 1) {
    navigate(-1);
  } else {
    navigate(HOME_PATH);
  }
}
